export const SET_ACTIVITIES = 'activity/SET_ACTIVITIES';
export const ADD_ACTIVITY = 'activity/ADD_ACTIVITY';
export const UPDATE_ACTIVITY = 'activity/UPDATE_ACTIVITY';
export const SET_ACTIVITY_SORT_FIELD = 'activity/SET_ACTIVITY_SORT_FIELD';
export const SET_ACTIVITY_SORT_DIRECTION = 'activity/SET_ACTIVITY_SORT_DIRECTION';
export const SET_ACTIVITY_FILTER_FIELD_VALUE = 'activity/SET_ACTIVITY_FILTER_FIELD_VALUE';
export const UPDATE_ACTIVITY_FILTERS = 'activity/UPDATE_ACTIVITY_FILTERS';
export const CLEAR_ACTIVITY_FILTERS = 'activity/CLEAR_ACTIVITY_FILTERS';
export const DELETE_ACTIVITY = 'activity/DELETE_ACTIVITY';
